import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import LayoutRoutes from "./LayoutRoutes";
import Login from "../Component/Authentication/Login";
import { useAuth } from "../context/AuthContext";
import ForgetPassword from "../Component/Authentication/ForgetPassword";
import NewPassword from "../Component/Authentication/NewPassword";

const RouterData = () => {
  const { isAuthenticated, loading } = useAuth();
  // const login = localStorage.getItem("login");
  if (loading) return null; // or a loader
  return (
    <BrowserRouter basename={"/"}>
      <Routes>
        {isAuthenticated ? (
          <>
            <Route path={"/"} element={<Navigate to={`/dashboard`} />} />
          </>
        ) : (
          ""
        )}
        <Route path={"/"} element={<PrivateRoute />}>
          <Route path={`/*`} element={<LayoutRoutes />} />
        </Route>
        <Route path={`/login`} element={<Login />} />
        <Route path={`/forgot-password`} element={<ForgetPassword />} />
        <Route path={`/reset-password/:token`} element={<NewPassword />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterData;
